"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import PhoneLogin from "@/app_views/login/components/PhoneLogin.vue";
import WxLogin from "@/app_views/login/components/WxLogin.vue";
import WxReg from "@/app_views/login/components/WxReg.vue";
import PhoneBind from "@/app_views/login/components/PhoneBind.vue";
import VersionTip from "@/app_views/login/components/VersionTip.vue";
const bubbleImage = require("@/assets/img/login_bubble.jpg");
import UrlTools from "@/utils/UrlTools";
import API from "@ym-framework/api-utils";
import LoginLayout from "@/app_views/LoginLayout.vue";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import ProgressComponent from "@/components/progress/Progress.vue";
import DownloadTipDialog from "@/app_views/homePage/DownloadTipDialog.vue";
let AuthBubble = class extends Vue {
  constructor() {
    super(...arguments);
    this.webSocketViewService = WebsocketViewService;
    this.bubble_image = bubbleImage;
    this.bubble_loading = false;
    this.isLogin = false;
    this.isQrCode = true;
    this.isBindPhone = false;
    this.isForgetPassword = false;
    this.isNeedUpdated = false;
    this.isLoading = false;
    this.downloadTip = "";
    this.downloadUrl = "";
    this.downloadVersion = "";
    this.jump = "";
    this.refer = "";
    this.showUpdate = false;
    this.showLock = false;
    this.hideAction = false;
    this.notify = null;
    this.notifyInstall = null;
    this.auth_images = [];
  }
  mounted() {
    return __async(this, null, function* () {
      this.webSocketViewService._ipcEvent.on(
        "event:update.auto.download",
        (data) => __async(this, null, function* () {
          this.updateStart();
          this.isNeedUpdated = true;
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:update.need.download",
        (data) => __async(this, null, function* () {
          if (!sessionStorage.getItem("updata_message_notify")) {
            this.downloadTip = data.tip;
            this.downloadUrl = data.url;
            this.downloadVersion = data.last;
            this._download_tip_dialog.open();
          }
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:update.force.install",
        (data) => __async(this, null, function* () {
          this.installStart();
          this.isNeedUpdated = true;
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:update.need.install",
        (data) => __async(this, null, function* () {
          this.installStart();
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:pageEvent.start.install",
        (data) => __async(this, null, function* () {
          this.updateStart();
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:pageEvent.close.notification",
        (data) => __async(this, null, function* () {
          this.closeNotify();
        })
      );
      if (this.$route.query.hasOwnProperty("refer")) {
        this.refer = this.$route.query.refer;
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.jump = this.$route.query.page;
      }
      try {
        let response = yield API.get(`api://base.local/system/locale`);
        if (response.data.locale === "zh-CN" || response.data.locale === "en-US" || response.data.locale === "es-ES") {
          this.$i18n.locale = response.data.locale;
          document.documentElement.lang = response.data.locale;
          localStorage.setItem("lang", response.data.locale);
        } else {
          this.$i18n.locale = "zh-CN";
          document.documentElement.lang = "zh-CN";
          localStorage.setItem("lang", "zh-CN");
        }
      } catch (error) {
        this.$i18n.locale = "zh-CN";
        document.documentElement.lang = "zh-CN";
        localStorage.setItem("lang", "zh-CN");
      }
      yield this.checkUpdate();
      yield this.GetLoginImage();
      const _mode = localStorage.getItem("loginmode") || "phone";
      this.isLogin = true;
      if (_mode === "phone") {
        this.isQrCode = false;
      }
      if (_mode === "wechat") {
        this.isQrCode = true;
      }
      let _status = UrlTools.query("tab") || "login";
      if (_status === "login") {
        this.isLogin = true;
      }
      if (_status === "register") {
        this.isLogin = false;
      }
    });
  }
  updateStart() {
    if (this.showUpdate === true) {
      return;
    }
    this.showUpdate = true;
    const h = this.$createElement;
    this.notify = this.$notify({
      title: this.$t("homepage.downloading"),
      dangerouslyUseHTMLString: true,
      duration: 0,
      message: h(ProgressComponent)
    });
  }
  hideFlag(flag) {
    if (flag === "account") {
      this.hideAction = false;
    }
    if (flag === "user") {
      this.hideAction = true;
    }
  }
  installStart() {
    if (this.showLock === true && this.notifyInstall !== null) {
      return;
    }
    this.showLock = true;
    const h = this.$createElement;
    let that = this;
    this.notifyInstall = this.$notify({
      title: this.$t("homepage.installing"),
      duration: 0,
      message: h("div", {}, [
        h("el-button", { props: { type: "text" }, on: {
          click: this.startInstall
        } }, this.$t("homepage.start_install")),
        h("el-button", { props: { type: "text" }, style: "color:#c0c4d4", on: {
          click: () => {
            this.installNextTime();
            this.notifyInstall.close();
            this.notifyInstall = null;
          }
        } }, this.$t("homepage.next_time"))
      ]),
      onClose() {
        that.notifyInstall = null;
      }
    });
  }
  installNextTime() {
    return __async(this, null, function* () {
      sessionStorage.setItem("install_message_notify", "show");
      yield API.put(`api://base.local/storages/session/updateInstall`, {
        "message": "no.need.install",
        "model": "no.need.install"
      });
    });
  }
  startInstall() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.local/update/install`);
      } catch (error) {
        console.log(error);
      }
    });
  }
  closeNotify() {
    this.notify.close();
    this.notify = null;
  }
  checkUpdate() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.local/websockets/root`, {
          model: "check.update",
          value: {
            message: "check.update"
          }
        });
      } catch (error) {
      }
    });
  }
  GetLoginImage() {
    return __async(this, null, function* () {
      try {
        this.auth_images = [];
        let response = yield API.get(`api://base/api/v7_1/account/slide_show`, {
          params: {
            auth_type: "login"
          }
        });
        this.auth_images = response.data.datas;
      } catch (error) {
        console.log(error);
      }
    });
  }
  toForgetPassword() {
    window.open("https://app.kuajingvs.com/forgetpassword", "_blank");
  }
  toRegisterApp() {
    if (!this.isQrCode) {
      window.open("https://app.kuajingvs.com/register", "_self");
    } else {
      this.isLogin = false;
    }
  }
  changeQr() {
    this.isQrCode = !this.isQrCode;
    if (this.isQrCode) {
      localStorage.setItem("loginmode", "wechat");
    } else {
      this.isLogin = true;
      localStorage.setItem("loginmode", "phone");
    }
  }
  changeQrCode(isQrCode) {
    this.isQrCode = isQrCode;
    if (isQrCode) {
      localStorage.setItem("loginmode", "wechat");
    } else {
      this.isLogin = false;
      localStorage.setItem("loginmode", "phone");
    }
  }
  toClose() {
    console.log("kjvs://close");
  }
};
__decorateClass([
  Ref("phone-login")
], AuthBubble.prototype, "phone_login", 2);
__decorateClass([
  Ref("download_tip_dialog")
], AuthBubble.prototype, "_download_tip_dialog", 2);
AuthBubble = __decorateClass([
  Component({
    components: {
      PhoneLogin,
      WxReg,
      WxLogin,
      PhoneBind,
      VersionTip,
      LoginLayout,
      ProgressComponent,
      DownloadTipDialog
    }
  })
], AuthBubble);
export {
  AuthBubble as default
};
